import { render } from "./verify.vue?vue&type=template&id=8838f9b0&ts=true"
import script from "./verify.vue?vue&type=script&lang=ts"
export * from "./verify.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__